import { useEffect } from 'react';

/**
 * Set the document <title> and <meta name="description"> when a route mounts.
 * Lives in a tiny hook (rather than a router config) because Cash Forth's
 * routing is window.location-based, not react-router.
 *
 * NOTE: Social link previews use the static tags in public/index.html
 * (Facebook / Twitter / LinkedIn scrapers do not run JS). This hook is for
 * humans — browser tab titles, bookmark labels, screen readers.
 */
export function useDocumentMeta({ title, description }) {
  useEffect(() => {
    if (title) {
      document.title = title;
    }
    if (description) {
      let tag = document.querySelector('meta[name="description"]');
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute('name', 'description');
        document.head.appendChild(tag);
      }
      tag.setAttribute('content', description);
    }
  }, [title, description]);
}
